const uniformeModulo = {
    agGrid: {
        paginacion: 15,
        id: 'myGrid',
        class: 'ag-theme-alpine mt-3',
        style: {
            width: '100%',
            height: '400px'
        }
    },
    agGridModal: {
        paginacion: 10,
        id: 'myGrid',
        class: 'ag-theme-alpine mt-3',
        style: {
            width: '100%',
            height: '450px'
        }
    },
    url: {
        seguridad: {
            recuperacion: 'usuario/account/reset-password/init',
            changeUser: 'usuario/account/change-password'
        },
        uniforme: {
            parametroIncial: 'parametros_inicial',
            grupoSize: 'grupo_size',
            clothes: 'clothes',
            size: 'size',
            syncStatus: 'syncStatus',
            clothesEmploye: {
                url: 'clothes_employee',
                findInfoEmploye: '/data_employee',
                reset_quote: '/reset_quotas'
            },
            deliver:{
                url: 'deliver_clothes',
                findInfoEmploye: '/data_employee',
                findSizeClothes: '/size_clothes',
            },
            report:{
                url: 'report',
                actaEntrega: '/recep'
            },
            aplicacion: 'aplication',
            tipoAplicacion: 'tipo_app',
            aplicacionUser: 'aplication_user',
            caracteristica: 'caracteristica',
            empleado: 'empleado/',
            sincronizar:{
                da: 'syncDA/updateInfo',
            },
        },
        onlyControl: {
            updateFoto: 'syncDA/updateFoto/',
            syncPhotoStatus: 'syncPhotoStatus'
        }
    },
    button: {
        buttonsCss: {
            primary: 'btn btn-primary btn-block',
            secondary: 'btn btn-secondary btn-block',
            success: 'btn btn-success btn-block',
            danger: 'btn btn-danger btn-block',
            warning: 'btn btn-warning btn-block',
            info: 'btn btn-info btn-block',
            light: 'btn btn-light btn-block',
            dark: 'btn btn-dark btn-block',
            primaryOutline: 'btn btn-outline-primary',
            secondaryOutline: 'btn btn-outline-secondary',
            successOutline: 'btn btn-outline-success',
            dangerOutline: 'btn btn-outline-danger',
            warningOutline: 'btn btn-outline-warning',
            infoOutline: 'btn btn-outline-info',
            lightOutline: 'btn btn-outline-light',
            darkOutline: 'btn btn-outline-dark',
            primarylg: 'btn btn-primary btn-lg btn-block',
            successLg: 'btn btn-success btn-lg btn-block',
            dangerLg: 'btn btn-danger btn-lg btn-block',
            warningLg: 'btn btn-warning btn-lg btn-block',
            warningLgFile: 'btn btn-warning btn-lg btn-block btn-file',
        },
        buttonsNombre: {
            editar: 'Editar',
            ver: 'Ver',
            eliminar: 'Eliminar',
            agregar: 'Agregar ',
            guardar: 'Guardar',
            actualizar: 'Actualizar',
            mostrar: 'Mostrar seleccion',
            regresar: 'Regresar',
            continuar: 'Continuar',
            seleccionar: 'Seleccionar',
            procesar: 'Procesar',
            buscar: 'Buscar',
            sustento: 'Sustento',
            validar: 'Validar',
            descargar: 'Descargar',
            descargarRecibo: 'Descargar Recibo Cobros',
            descargarEstado: 'Descargar Estados Docs',
            detalle: 'Ver Ordenes',
            agregarProducto: 'Añadir Productos',
            anadirProducto: 'Añadir',
            limpiar: 'Eliminar todos los productos',
            anular: 'Anular',
            aprobar: 'Aprobar',
        }
    },
    mensajes: {
        errorServicio: 'error..!!',
        desabilitada: 'Opción desabilitada',
        eliminar: '¿Esta seguro que desea eliminar el siguiente elemento?',
        guardar: '¿Esta seguro que desea guardar?',
        actualizar: '¿Esta seguro que desea actualizar el siguiente elemento?',
        datoGuardado: 'Se guardo corectamente..!!',
        guardarParada: 'Esta seguro que desea registrar este evento..??',
        procesar: '¿Esta seguro que desea procesar el siguiente elemento?',
        validar: '¿Esta seguro que desea validar el siguiente elemento?',
        anticipo: 'Se tomara este valor como anticipo.',
        camposObligatorio: 'Los campos tipo transaccion y número documento deben estar llenos caso contrario se tomara como anticipo.',
        anular: 'Confirma que desea eliminar el registro seleccionado.',
    },
    colors: {
        verde: 'green',
        azul: 'blue',
        rojo: 'red'
    },
    imagenes: {
        regalo: '<span><img src="../../../assets/image/regalo.png" height="30" width="30"></i></span>',
        item: '<span><img src="../../../assets/image/regalo.png" height="30" width="30"></i></span>'
    },
    div: {
        resposiveFull: 'col-12 col-sm-6 col-md-6 col-lg-4 ',//verificar el tipo de pantalla
    }
}

export { uniformeModulo }